import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import ConfigCenterGateway from '@api/gateway/ConfigCenter-default'
import queryGraphql from './query.graphql'

interface ConfigType {
  key: string
  value: string
}

interface Config {
  ingress: Array<ConfigType>
  application: Array<ConfigType>
}

export interface ConfigCenterState {
  ingress: Map<string, string>
  application: Map<string, string>
}

@Module({ namespaced: true, dynamic: true, store, name: 'ConfigCenterModule' })
class ConfigCenterModule extends VuexModule implements ConfigCenterState {
  ingress = new Map<string, string>()
  application = new Map<string, string>()

  @Action
  async getNamespacesConfig() {
    const { data } = await ConfigCenterGateway._commonQuery(queryGraphql, undefined)
    this.SET_NAMESPACES_CONFIG(data as any)
  }

  @Mutation
  SET_NAMESPACES_CONFIG(config: Config) {
    config.ingress.forEach((ingress: ConfigType) => {
      this.ingress.set(ingress.key, ingress.value)
    })
    config.application.forEach((application: ConfigType) => {
      this.application.set(application.key, application.value)
    })
  }

  get getApplicationByName() {
    return (name: string) => {
      return this.application.get(name) || ''
    }
  }

  get getIngressByName() {
    return (name: string) => {
      return this.ingress.get(name) || ''
    }
  }
}

export default getModule(ConfigCenterModule)
